import * as e from "react";
import a from "../lib/SSRBase.es.js";
import i from "../defs/ChartLineUp.es.js";
const r = e.forwardRef((t, o) => /* @__PURE__ */ e.createElement(a, { ref: o, ...t, weights: i }));
r.displayName = "ChartLineUpIcon";
const p = r;
export {
  p as ChartLineUp,
  r as ChartLineUpIcon
};
